import React from "react";

import { ScrollToTopOnMount } from "../../components/common/ScrollToTopOnMount";
import TopShadow from "../../components/common/TopShadow";
import Footer from "../../components/Footer";
import CheckoutLayout from "../../layouts/checkout";

import "./checkout.scss";

const CheckoutPage = () => {
  return (
    <div className="page_container">
      <ScrollToTopOnMount />
      <TopShadow color="gray" />
      <div className="checkout_container">
        <CheckoutLayout />
      </div>
      <div className="footer">
        <Footer />
      </div>
    </div>
  );
};

export default CheckoutPage;
